/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Lustrace_Status_Not_ConfiguredInputs */

const cs_property_lustrace_status_not_configured = /** @type {(inputs: Property_Lustrace_Status_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenastaveno`)
};

const en_property_lustrace_status_not_configured = /** @type {(inputs: Property_Lustrace_Status_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not configured`)
};

/**
* | output |
* | --- |
* | "Not configured" |
*
* @param {Property_Lustrace_Status_Not_ConfiguredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_lustrace_status_not_configured = /** @type {((inputs?: Property_Lustrace_Status_Not_ConfiguredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Lustrace_Status_Not_ConfiguredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_lustrace_status_not_configured(inputs)
	return cs_property_lustrace_status_not_configured(inputs)
});